export function firstErrorMessage(error, fallback) {
  if (Array.isArray(error) && error.length) return error[0];
  if (typeof error === "string") return error;
  if (error?.message) return error.message;

  return fallback;
}
